const namespace = {
  summaryTitle: "About the neighborhood",
} as const;

export default namespace;
